const authentication = require('../../../react-azure-adb2c2').default;
// export function update( values: any) {

// console.log(values)





export function change(values: any) {

    const token = authentication.getAccessToken();

    // const url = `http://localhost:5000/api/v1/rent/responses/kidoku`
    const url = process.env.REACT_APP_API_CRM_URL + `/api/v1/rent/responses/kidoku`

    // const search = values ? values : {};
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}


